/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react'
import NavigationBar from '../components/NavBar'
import Dropdown from 'react-dropdown'
import '../App.scss'

var theManager = null
var submitString = ''
var deleteSubmitString = ''
var localName = ''
var localEmail = ''

// have an object that can make the mapping process easy
var stationMap = {
    'DBS2': 0,
    'DEX2': 1,
    'DXP1': 2,
    'DCF1': 3,
    'DSN1': 4
}

var stationArray = ['DBS2', 'DEX2', 'DXP1', 'DCF1', 'DSN1']


const CreateManager = (props) => {
    var CryptoJS = require("crypto-js");
    const [ submitPressed, setSubmitPressed ] = useState('Submit')
    const [ data, setData ] = useState(null)
    const [ managerList, setManagerList ] = useState([])
    const [ selectedManager, setSelectedManager ] = useState(null)
    const [ content, setContent ] = useState(null)
    const [ reload, setReload ] = useState(0)
    const [ errorMessage, setErrorMessage ] = useState(null)
    const [ editClass, setEditClass ] = useState('create_manager_form')
    const [ name, setName ] = useState('')
    const [ email, setEmail ] = useState('')
    const [ station, setStation ] = useState([])
    const [ selectedCitySubmit, setSelectedCitySubmit ] = useState('')
    const [ deleteSelect, setDeleteSelect ] = useState('')
    const [ editGate, setEditGate ] = useState(false)
    const [ submitedGate, setSubmitedGate ] = useState(false)
    const [checkBoxArray, setCheckBoxArray] = useState([false, false, false, false, false])
    const [selectAllText, setSelectAllText] = useState('Select All')

    // make the managers special
    useEffect( () => {
        async function getData(url = '') {
            let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
            let originalText = bytes.toString(CryptoJS.enc.Utf8);
            const response = await fetch(url, {
                method: 'GET', 
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${originalText}`
                }
            });
            return response ? response.json() : console.log('no reponse')
        };

        async function putData(url = '', data={}) {
            let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
            let originalText = bytes.toString(CryptoJS.enc.Utf8);
            const response = await fetch(url, {
                method: 'PUT', 
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${originalText}`
                },
                body: JSON.stringify(data)
            });
            return response ? response.json() : console.log('no reponse')
        };

        getData('https://backendpajamas.herokuapp.com/drivers/').then( response => {
            let driverArray = response.results
            getData('https://backendpajamas.herokuapp.com/managers/').then( response => { 
                driverArray.forEach( driver => {
                    response.results.forEach( manager => {
                        if (manager.email === driver.email) {
                            putData(`https://backendpajamas.herokuapp.com/drivers/${driver.driver_id}/`, {
                                Signed: true
                            })
                        }
                    })
                })
            })
        })
    }, [submitedGate])

    useEffect( () => {
        async function getData(url = '') {
            let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
            let originalText = bytes.toString(CryptoJS.enc.Utf8);
            const response = await fetch(url, {
                method: 'GET', 
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${originalText}`
                }
            });
            return response ? response.json() : console.log('no reponse')
        };

        getData('https://backendpajamas.herokuapp.com/managers/').then( response => {
            console.log(response)
            setData(response)
        })
    }, [submitPressed, reload])

    // function for displaying list of stations
    const stationDisplay = (user) => {
        let thisVar = 0
        let localList = []
        user.DBS2 ? localList.push('DBS2') : thisVar++
        user.DEX2 ? localList.push('DEX2') : thisVar++
        user.DSN1 ? localList.push('DSN1') : thisVar++
        user.DXP1 ? localList.push('DXP1') : thisVar++
        user.DCF1 ? localList.push('DCF1') : thisVar++
        return localList
    }

    // make them pretty 

    const prettifyThem = (arrayOfItems) => {
        let localArray = []
        if (arrayOfItems.length > 0) {
            arrayOfItems.forEach( ele => {
                localArray.push(
                    <h3 className='stationList'>{ele} |</h3>
                )
            })
        }
        return localArray
    }

    // set the backend string
    useEffect( () => {
        submitString = selectedCitySubmit
    }, [selectedCitySubmit])

    // set the backend string
    useEffect( () => {
        deleteSubmitString = deleteSelect
    }, [deleteSelect])

    // create manger
    const handleSubmit = (e) => {
        e.preventDefault();
        // email bit
        async function postData(url = '', data={}) {
            let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
            let originalText = bytes.toString(CryptoJS.enc.Utf8);
            const response = await fetch(url, {
                method: 'POST', 
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${originalText}`
                },
                body: JSON.stringify(data)
            });
            return response ? response.json() : console.log('no reponse')
        };

        let finalArray = checkBoxArray.map((ele, eleId) => {
            console.log(ele, eleId)
            if (ele) {
                return stationArray[eleId]
            } else {
                return -1
            }
        })

        postData('https://backendpajamas.herokuapp.com/managers/', {
            name: e.target.name.value,
            email: e.target.email.value,
            DBS2: finalArray.includes('DBS2') ? true : false,
            DEX2: finalArray.includes('DEX2') ? true : false,
            DSN1: finalArray.includes('DSN1') ? true : false,
            DXP1: finalArray.includes('DXP1') ? true : false,
            DCF1: finalArray.includes('DCF1') ? true : false,
        }).then( response => {
            setCheckBoxArray([false, false, false, false])
            setSubmitPressed('Created')
            setTimeout(() => {
                setSubmitPressed('Submit')
            }, 5000)
        })
        submitedGate === false ? setSubmitedGate(true) : setSubmitedGate(false)
    }

    // edit manager
    const handleSubmitEdit = (e,  manager) => {
        e.preventDefault();
        let checkerArray = stationDisplay(manager)
        // eslint-disable-next-line no-self-assign
        submitString.length > 1 && submitString !== 'none' ? checkerArray.push(submitString) : checkerArray = checkerArray
        // email bit
        async function getData(url = '', data={}) {
            let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
            let originalText = bytes.toString(CryptoJS.enc.Utf8);
            const response = await fetch(url, {
                method: 'PUT', 
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${originalText}`
                },
                body: JSON.stringify(data)
            });
            return response ? response.json() : console.log('no reponse')
        };

        const makeList = () => {
            let myObj = {
                name: e.target.name.value ? e.target.name.value : manager.name,
                email: e.target.email.value ? e.target.email.value : manager.email,
                DBS2: checkerArray.includes('DBS2') && deleteSubmitString !== 'DBS2'? true : false,
                DEX2: checkerArray.includes('DEX2') && deleteSubmitString !== 'DEX2'? true : false,
                DSN1: checkerArray.includes('DSN1') && deleteSubmitString !== 'DSN1'? true : false,
                DXP1: checkerArray.includes('DXP1') && deleteSubmitString !== 'DXP1'? true : false,
                DCF1: checkerArray.includes('DCF1') && deleteSubmitString !== 'DCF1'? true : false
            }
            return myObj
        }

        getData(`https://backendpajamas.herokuapp.com/managers/${manager.user_id}/`, makeList()).then( response => {
            setName('')
            setEmail('')
            let myNum = reload
            let myNextNum = myNum += 1
            setReload(myNextNum)
            setContent(            
                <div>
                    <form onSubmit={handleSubmit} className='create_manager_form'>
                        <label className='labels_create_manager'>Name</label>
                            <input className='inputs_create_manager' type="text" value={name} name="name" onChange={handleChange} required/>
                        <label className='labels_create_manager'>Email</label>
                            <input className='inputs_create_manager' type="text"  value={email} name="email" onChange={handleChange}required/>   
                        <label className='labels_create_manager'>Station List</label>   
                        <div>
                            {station}
                        </div>                 
                        <label className='labels_create_manager'>Station</label>
                            <Dropdown 
                                options={options} 
                                onChange={onSelect} 
                                value={selectedCitySubmit} 
                                placeholder="Select an option" 
                                className='drop_down_bar_dashboard'
                                id='drop_down_style'
                            />
                        <br />    
                        <input type="submit" value={submitPressed} className='compliance_add_driver_button_submit' />
                    </form>
                </div>
            )
        })
    }

    // dropdown menu options a commetn
    const options = [
        'none',
        'DBS2',
        'DSN1',
        'DEX2',
        'DXP1',
        'DCF1'
    ]

    // function for setting the station
    const onSelect = (e) => {
        setSelectedCitySubmit(e.value)
    }

    // function for setting the station
    const onSelectDelete = (e) => {
        setDeleteSelect(e.value)
    }

    // actually delete
    const actuallyDelete = () => {
        async function deleteData(url = '') {
            let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
            let originalText = bytes.toString(CryptoJS.enc.Utf8);
            const response = await fetch(url, {
                method: 'DELETE', 
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${originalText}`
                }
            });
        };
        if (theManager) {
            deleteData(`https://backendpajamas.herokuapp.com/managers/${theManager.user_id}/`)
            let myNum = reload
            let myNextNum = myNum += 1
            setReload(myNextNum)
            handleReturn()
        } else {
            setErrorMessage(
                <div className='makeMeBig'> 
                    <div className='deletionObjectionTwo'>
                        Manager not selected?
                        <div>
                            <button className='returnButton' onClick={handleReturn}>Return</button> 
                        </div>
                    </div>
                </div>
            )
        }
    }

    // handle not deleting
    const handleReturn = () => {
        setErrorMessage(null)
    }

    // allow deleting
    const handleDeleteClick = (e) => {
        e.preventDefault()
        setErrorMessage(
            <div className='makeMeBig'> 
                <div className='deletionObjectionTwo'>
                    would you like to remove this day?
                    <div>
                        <button className='deleteButton' onClick={actuallyDelete}>Delete</button> 
                        <button className='returnButton' onClick={handleReturn}>Return</button> 
                    </div>
                </div>
            </div>
        )
    }
    // make the div stay grey
    useEffect( () => {
        let localArray = []
        if (data) {
            data.results.forEach( (manager, managerID) => {
                if (manager.user_id === selectedManager.user_id) {
                    localArray.push(
                        <div key={manager.user_id} className='managerDivSelected' onClick={(e, theManager) => handleClick(e, manager)}>
                            <div>
                                Name: {manager.name}
                            </div>
                            <div>
                                Email: {manager.email}
                            </div>
                            <div>
                                Station: {prettifyThem(stationDisplay(manager))}
                            </div>
                        </div>
                    )
                } else {
                    localArray.push(
                        <div key={manager.user_id} className='managerDiv' onClick={(e, theManager) => handleClick(e, manager)}>
                            <div>
                                Name: {manager.name}
                            </div>
                            <div>
                                Email: {manager.email}
                            </div>
                            <div>
                                Station: {prettifyThem(stationDisplay(manager))}
                            </div>
                        </div>
                    )
                }
            })
        }
        setManagerList(localArray)
    }, [selectedManager])

    // function for changing state
    const handleChange= (e) => {
        if (e.target.name === 'name') {
            setName(e.target.value)
        } else if (e.target.name === 'email') {
            setEmail(e.target.value)    
        }
    }

    // return to submit new
    const handleReturnClick = () => {
        setEditGate(false)
        setName('')
        setEmail('')
        setContent(               
            <div>
                <form onSubmit={handleSubmit} className='create_manager_form'>
                    <label className='labels_create_manager'>Name</label>
                        <input className='inputs_create_manager' type="text" value={name} name="name" onChange={handleChange} required/>
                    <label className='labels_create_manager'>Email</label>
                        <input className='inputs_create_manager' type="text"  value={email} name="email" onChange={handleChange} required/>   
                    <label className='labels_create_manager'>Station List</label>   
                    <div>
                    
                    </div>                 
                    {/* <label className='labels_create_manager'>Station</label>
                        <Dropdown 
                            options={options} 
                            onChange={onSelect} 
                            value={selectedCitySubmit} 
                            placeholder="Select an option" 
                            className='drop_down_bar_dashboard'
                            id='drop_down_style'
                        /> */}
                    <br />    
                    <input type="submit" value={submitPressed} className='compliance_add_driver_button_submit' />
                </form>
            </div>
        )
    }

    // allow editing
    const handleClick = (e, manager) => {
        setEditGate(true)
        setSelectedManager(manager)
        theManager = manager
        let listOfStation = stationDisplay(manager)
        async function makeState() {
            setName(manager.name)
            setEmail(manager.email)
            return true
        }
        makeState()
    }

    // make the edit content
    useEffect( () => {
        if (editGate === true) {
            setContent(
                <div>
                    <form onSubmit={(e, theManager) => handleSubmitEdit(e, selectedManager)} className={editClass} >
                        <label className='labels_create_manager'>Name</label>
                            <input className='inputs_create_manager' type="text" value={name} name="name" onChange={handleChange} required/>
                        <label className='labels_create_manager'>Email</label>
                            <input className='inputs_create_manager' type="text" value={email} name="email" onChange={handleChange} required/>     
                        <label className='labels_create_manager'>Station List</label>               
                            <div>
                                {prettifyThem(stationDisplay(selectedManager))}
                            </div>                 
                            <label className='labels_create_manager'>Add Station</label>
                                <Dropdown 
                                    options={options} 
                                    onChange={onSelect} 
                                    value={selectedCitySubmit} 
                                    placeholder="Select an option" 
                                    className='drop_down_bar_dashboard'
                                    id='drop_down_style'
                                />
                            <br />    
                            <label className='labels_create_manager'>Remove Station</label>
                                <Dropdown 
                                    options={options} 
                                    onChange={onSelectDelete} 
                                    value={deleteSelect} 
                                    placeholder="Select an option" 
                                    className='drop_down_bar_dashboard'
                                    id='drop_down_style'
                                />
                            <br />    
                        <div className='multiButtons'>
                            <input type="submit" value='Edit' className='compliance_add_driver_button_submit' />
                            <button className='compliance_add_driver_button_submit' onClick={handleDeleteClick}>Delete</button>
                            <button className='compliance_add_driver_button_submit' onClick={handleReturnClick}>Return</button>
                        </div> 
                    </form>
                </div>
            )
        }
    }, [data, name, email, selectedManager])

    // handle mapping the textboxes to the array in state
    const handleCheckboxChange = (e) => {

        // make an array that can be edited locally
        let localCheckBoxArray = [...checkBoxArray]

        // change the local array and set it to state
        localCheckBoxArray[stationMap[e.target.name]] === true ? localCheckBoxArray[stationMap[e.target.name]] = false : localCheckBoxArray[stationMap[e.target.name]] = true;
        setCheckBoxArray(localCheckBoxArray)

        // reducer for cheking if all items are equal
        function checkEquality(accumulator, currentValue) {
            if (accumulator === currentValue) {
                return currentValue
            } else {
                return NaN
            }
        }

        // handle changing the text for the select button 
        switch (localCheckBoxArray.reduce(checkEquality, localCheckBoxArray[0])) {
            case true:
                setSelectAllText('Deselect All')
                break;
            default:
                setSelectAllText('Select All')    
                break;
        }
    }

    // handle the select all button
    const handleSelectAllButton = (e) => {
        e.preventDefault()
        
        // allow for handling select and deselect
        if (selectAllText === 'Select All') {
    
            // make all of the array true
            setCheckBoxArray([true, true, true, true, true])
    
            // make the text deselct all
            setSelectAllText('Deselect All')

        } else {
            // make all of the array true
            setCheckBoxArray([false, false, false, false, false])

            // make the text deselct all
            setSelectAllText('Select All')
        } 
    }

    useEffect( () => {
        if (editGate === false) {
            let localArray = []
            if (data) {
                data.results.forEach( (manager, managerID) => {
                    localArray.push(
                        <div key={managerID} className='managerDiv' onClick={(e, theManager) => handleClick(e, manager)}>
                            <div>
                                Name: {manager.name}
                            </div>
                            <div>
                                Email: {manager.email}
                            </div>
                            <div>
                                Station: {prettifyThem(stationDisplay(manager))}
                            </div>
                        </div>
                    )
                })
            }
            setContent(               
                <div>
                    <form onSubmit={handleSubmit} className='create_manager_form'>
                        <label className='labels_create_manager'>Name</label>
                            <input className='inputs_create_manager' type="text" value={name} name="name" onChange={handleChange} required/>
                        <label className='labels_create_manager'>Email</label>
                            <input className='inputs_create_manager' type="text"  value={email} name="email" onChange={handleChange}required/>   
                        <label className='labels_create_manager'>Station List</label>   
                        <div className='inputStationBox' onChange={handleCheckboxChange}>
                            <div>
                                <label htmlFor="DBS2">DBS2</label>
                                    <input type="checkbox" name="DBS2" checked={checkBoxArray[0]}/>
                            </div>
                            <div>
                                <label htmlFor="DEX2">DEX2</label>
                                    <input type="checkbox" name="DEX2" checked={checkBoxArray[1]}/>
                            </div>
                            <div>
                                <label htmlFor="DXP1">DXP1</label>
                                    <input type="checkbox" name="DXP1" checked={checkBoxArray[2]}/>
                            </div>
                            <div>
                                <label htmlFor="DCF1">DCF1</label>
                                    <input type="checkbox" name="DCF1" checked={checkBoxArray[3]}/>
                            </div>
                            <div>
                                <label htmlFor="DSN1">DSN1</label>
                                    <input type="checkbox" name="DSN1" checked={checkBoxArray[4]}/>
                            </div>
                        </div>      
                        <div className='selectAllButton'>
                            <button onClick={handleSelectAllButton}>{selectAllText}</button>    
                        </div>           
                        {/* <label className='labels_create_manager'>Station</label>
                            <Dropdown 
                                options={options} 
                                onChange={onSelect} 
                                value={selectedCitySubmit} 
                                placeholder="Select an option" 
                                className='drop_down_bar_dashboard'
                                id='drop_down_style'
                            /> */}
                        <br />    
                        <input type="submit" value={submitPressed} className='compliance_add_driver_button_submit' />
                    </form>
                </div>
                )
            setManagerList(localArray)
        }
    }, [data, name, email, checkBoxArray, selectAllText])

    return (
        <>
        {errorMessage}
            <div className='home_content'>
                <NavigationBar title='Create Manager' superUser={props.superUser ? true : false} email={props.user_email}/>
                <div className='main_content_driver_documents'>
                    {content}
                    <div className='createManagerListDiv'>
                        {managerList}
                    </div>
                </div>
            </div>
        </>
    )
}

export default CreateManager